module.exports = __webpack_public_path__ + "static/MoselMap-7e2ded42c0c3c1c4f8be63ec0484f9f0.png";